module.exports = __webpack_public_path__ + "static/3-add91bf132996cbad1c630f3cd241167.jpg";